import { GoogleDateInterface, SpecialHoursStatus, TimeOfDayInterface } from '@vendasta/listing-products';

export interface SpecialHoursDateTimeInterface {
  status: SpecialHoursStatus;
  date: GoogleDateInterface;
  timeSpan?: SpecialHoursTimeSpan[];
}

export class SpecialHoursTimeSpan {
  startTime: TimeOfDayInterface;
  endTime: TimeOfDayInterface;
  is24Hours: boolean;

  constructor(startTime: TimeOfDayInterface, endTime: TimeOfDayInterface) {
    this.startTime = startTime;
    this.endTime = endTime;
    this.is24Hours = this.spanIs24Hours(startTime, endTime);
  }

  private spanIs24Hours(startTime: TimeOfDayInterface, endTime: TimeOfDayInterface): boolean {
    if (!startTime && !endTime) {
      return true;
    }
    if (!startTime.hours && !startTime.minutes && (!endTime || (endTime.hours === 24 && !endTime.minutes))) {
      return true;
    }
    return startTime.hours === endTime.hours && startTime.minutes === endTime.minutes;
  }
}
